/*
 * @Author: wangchao wchao_sr@neusiri.com
 * @Date: 2023-09-05 15:01:50
 * @LastEditors: wangchao wchao_sr@neusiri.com
 * @LastEditTime: 2023-09-06 15:44:32
 * @FilePath: \Collection\src\server\apis\9832.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_9832
 */

import { message } from 'ant-design-vue'
import {
  pdpCountdown_add_post,
  pdpCountdown_detail_post
} from 'server/modules/9832'

// 添加倒计时配置
export const pdpCountdown_add_post_ = async function(params) {
  const { success, data, retInfo } = await pdpCountdown_add_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询倒计时配置
export const pdpCountdown_detail_post_ = async function(state) {
  const params = {
    ...state.searchParams
  }
  const { success, data, retInfo } = await pdpCountdown_detail_post(params)
  const initData = {
    timeSet: new Date(),
    token: null, //用户Token
    bakPictureColor: '#000000', // countdownColor背景图片色值
    brandId: 1, //品牌Id
    channelId: 1, //渠道Id
    countdownBakColor: '#000000', //countdownColor倒计时背景色值
    countdownColor: '#ffffff', //countdownColor倒计时时间色值
    countdownCopywritingColor: '#000000', // countdownCopywritingColor倒计时文案色值
    countdownType: 0, // 倒计时类型。0-不对客，1-自定义倒计时，2-读取优惠券
    ouponCode: '', //优惠券编码
    currency: null, // 币种
    displayTime: new Date(), // 倒计时显示限制
    endTime: new Date(), //	活动结束时间
    id: null, // 倒计时配置id
    imageUrl: '', // imageUrl活动图片url
    lang: '',
    siteId: 1,
    startTime: new Date(), //活动开始时间
    terminalId: 1,
    title: '', //	标题
    titleColor: '#ffffff', // titleColor标题色值
    toEndCopywriting: '' //toEndCopywriting距结束文案
  }
  if (success) {
    let data_ = { ...data }
    delete data_.langs
    if (!data_) {
      data_ = {
        ...initData
      }
    }
    state.params = { ...data_ }
    state.langs = data ? data.langs : []
    const { langList = [], langs = [] } = state
    if (Array.isArray(langs) && !langs.length) {
      langList.map(v => {
        state.langs.push({
          title: '', //活动语言
          toEndCopywriting: '', //倒计时文案
          imageUrl: '', // imageUrl活动图片url
          langCode: v.value
        })
      })
    }

    console.log('state ', state)
    // message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
